import styled from 'styled-components';

export const Container = styled.div`
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  overflow-wrap: anywhere;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  p {
    margin: 0 0 12px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 16px 0 8px;
    color: inherit;
    font-family: inherit;
    font-weight: bold;
    line-height: 1.2;
    text-transform: none;
  }

  h1 {
    font-size: 22px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 18px;
  }

  h4,
  h5,
  h6 {
    font-size: 16px;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }

  a {
    color: #be1622;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 22px;
  }

  li {
    margin: 4px 0;
  }

  blockquote {
    margin: 0 0 12px;
    padding-left: 16px;
    border-left: 3px solid #dee2e6;
    color: #6c757d;
  }

  code {
    padding: 2px 5px;
    border-radius: 3px;
    background: #f8f9fa;
    color: inherit;
    font-family: monospace;
    font-size: 14px;
  }

  pre {
    margin: 0 0 12px;
    padding: 12px;
    overflow-x: auto;
    background: #f8f9fa;

    code {
      padding: 0;
      background: transparent;
    }
  }
`;
